module.exports = __webpack_public_path__ + "static/trados-badges-web-sdl-200x130-pine-315f543f90668a78853dbd586ef93350.jpg";